

















































import { Component, Model, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import IUser from '@/models/IUser'
import { slug } from '@/utils'

@Component
export default class UserNew extends Vue {
  @Getter
  public user!: IUser | null
  @Model('input', { type: Object, required: true })
  public newUser!: IUser
  private localeUserId = (this.newUser.userId || '').toLowerCase()

  public maxChar(user: IUser): number {
    return 20 - (user.alias ? user.alias.length : 0)
  }

  public get isMainUser(): boolean {
    if (!this.newUser) {
      return false
    }
    return !!this.user && this.user.userId === this.newUser.userId
  }

  public set userId(newUserId: string) {
    this.localeUserId = (newUserId || '').toLowerCase()
  }
  public get userId(): string {
    return this.localeUserId
  }

  @Watch('localeUserId', { immediate: true })
  public onLocaleUserIdChange(userId: string) {
    if (this.newUser.userId !== userId) {
      this.newUser.userId = userId
    }
  }
}
